export enum HORN_TYPES {
  NO_DIFFRACTION_SLOT,
  ALLOW_DIFFRACTION_SLOT,
  PRIORITISE_LOADING,
}

export enum GEOMETRY {
  Circular,
  Rectangular,
  Elliptical,
}

export enum THROAT_EXIT {
  one = "25mm/1.0in",
  oneFour = "36mm/1.4in",
  two = "51mm/2.0in",
}